<template>
  <v-app light>
    <AppHeader :navItems="navItems"/>
    <div v-if="isOutlets" class="outlets gd-background">
      <router-link :to="region.url" v-for="region in mappedRegions" class="outlets__item"
                   :key="region.name"
                   :style="`background-image: url(${getPath(region.image_url)})`">
        {{ region.name }}
      </router-link>
    </div>
    <router-view></router-view>
    <AppFooter :navShortcuts="navShortcuts"/>
  </v-app>
</template>

<script>
import nav from '../_nav'
import {Footer as AppFooter, Header as AppHeader} from '../components/'
import {mapGetters} from 'vuex'

export default {
  name: 'full',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      navItems: nav.items,
      navShortcuts: nav.shortcuts,
      title: 'Coffee Ketjil',
      mappedRegions: []
    }
  },
  created() {
    this.getRegions()
  },
  computed: {
    ...mapGetters(['regions']),
    isOutlets() {
      return this.$route.name === 'Outlets'
    }
  },
  methods: {
    getRegions() {
      this.$store.dispatch('getRegions', {
        success: () => {
          this.mappedRegions = this.regions.map(region => ({
            name: region.name,
            url: `/outlets/list/${region.id}`,
            icon: 'map-marker',
            image_url: region.image_url
          }))
          this.navItems.map(nav => {
            if (nav.name.toLowerCase() === 'outlets') {
              nav.childs = [...this.mappedRegions]
            }
          })
        },
        fail: () => {
        }
      })
    },
    getPath(fileName) {
      return 'https://api.kopiketjil.com' + fileName
    },
  }
}
</script>

<style class="scss">
.outlets {
  min-height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 24px 24px;

  .outlets__item {
    height: 200px;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: white;
    text-decoration: none;
    transition: all .3s ease;
    font-family: "Helvetica Neue Lt Std", sans-serif;
    font-size: 36px;

    &:hover {
      font-size: 48px;
    }

    @media screen and (min-width: 960px) {
      font-size: 80px;
      padding: 60px 24px;
      justify-content: space-between;
      gap: 16px;

      &:hover {
        font-size: 96px;
      }
    }
  }

  img {
    width: 100%;
    height: 480px;
    object-fit: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Full.vue